/**
 * Racine applicative : charge la session au démarrage puis affiche les routes.
 */

import type { ReactElement } from 'react';
import { useEffect } from 'react';

import { useAuth } from './auth/session';
import { AppRoutes } from './routes';

export default function App(): ReactElement {
  const { bootstrap } = useAuth();

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  return <AppRoutes />;
}
